import { CORE_API_HOST } from "../api-hosts";
import { httpClient } from "./http-client";

class AuthService {
    constructor() { }
    async get_refresh_token(req = {}) {
        return httpClient({
            url: `token/lifetime/extend/?`,
            baseURL: CORE_API_HOST,
            method: "post",
            data: { redirect_uri: location.origin + '/auth/callback' },
            headers: req.headers
        });
    }
}
export const authService = new AuthService();